import Rollbar from 'rollbar';

export function reportError(errorName, error) {
  if (errorName && error) Rollbar.error(errorName, error);
}

export function reportWarning(warningName, warning) {
  if (warningName && warning) Rollbar.warning(warningName, warning);
}

export function reportInfo(infoName, info) {
  if (infoName && info) Rollbar.info(infoName, info);
}

export function configureRollbarUser(userData) {
  const { id, username, email } = userData;
  const rollbarConfig = {
    accessToken: '3affd941e3d0437ea5f446c0a2769419',
    captureUncaught: true,
    payload: {
      environment: window.location.hostname,
      person: {
        id,
        username,
        email,
      },
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: 'latest',
          guess_uncaught_frames: true,
        },
      },
    },
  };

  Rollbar.configure(rollbarConfig);
}

export function configureAppcuesUser(userData) {
  const { id, username, email } = userData;
  Appcues.identify(id, {
    name: username,
    email,
    created_at: new Date(),
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/error-handling-service.js
 **/